import {useEffect, useState} from 'react';
import ReactSwitch from 'react-switch';

type WebhookToggleProps = {
  active: boolean;
  id: string;
  onChangeStatus: (id: string, value: boolean) => Promise<void>;
};

export const WebhookToggle = ({
  active,
  id,
  onChangeStatus,
}: WebhookToggleProps) => {
  const [checked, setChecked] = useState(active);

  useEffect(() => {
    setChecked(active);
  }, [active]);

  const onChange = async (isChecked: boolean) => {
    try {
      setChecked(isChecked);
      await onChangeStatus(id, isChecked);
    } catch (error) {
      setChecked(!isChecked);
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <label>
        <ReactSwitch
          onColor="#4285f4"
          onChange={onChange}
          handleDiameter={17}
          height={20}
          width={40}
          checked={checked}
          checkedIcon={false}
          uncheckedIcon={false}
        />
      </label>
    </div>
  );
};
